module.exports = __webpack_public_path__ + "img/total_cashfloat_icon.7043cfe5.png";